import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ModaleOuverture.scss';


function ModaleOuverture({ onClose, titre, message }) {
  const [isOpen, setIsOpen] = useState(true);
  const [youtubeId, setYoutubeId] = useState(null);

  useEffect(() => {
    if (message) {
      const youtubeLink = extractYoutubeId(message);
      if (youtubeLink) {
        setYoutubeId(youtubeLink);
      }
    }
  }, [message]);

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => onClose(), 280);
  };

  const extractYoutubeId = (text) => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = text.match(regex);
    return match ? match[1] : null;
  };

  const isYoutubeLink = (text) => {
    return text.startsWith("https://www.youtube.com/") || text.startsWith("https://youtu.be/");
  };

  const hasMessage = message && message.trim() !== '';

  return createPortal(
    <div className='modaleOuverture'>
      <div className={`modaleOuverture__overlay ${isOpen ? '' : 'closing'}`} onClick={handleClose}></div>
      <div className={`modaleOuverture__card ${isOpen ? '' : 'closing'}`}>

        <div className='modaleOuverture__top-bar'></div>

        <div className='modaleOuverture__header'>
          <span className='modaleOuverture__label'>En ce moment chez BAsique</span>
          <button onClick={handleClose} className="modaleOuverture__close" aria-label="Fermer">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className='modaleOuverture__body'>
          {hasMessage ? (
            <>
              {titre && <h2 className='modaleOuverture__titre'>{titre}</h2>}
              {!isYoutubeLink(message) && (
                <p className='modaleOuverture__message'>{message}</p>
              )}
              {youtubeId && (
                <div className="youtube-thumbnail">
                  <a href={`https://www.youtube.com/watch?v=${youtubeId}`} target="_blank" rel="noopener noreferrer">
                    <img src={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`} alt="YouTube Thumbnail" />
                  </a>
                </div>
              )}
            </>
          ) : (
            <p className='modaleOuverture__empty'>Pas de nouvelle, bonne nouvelle !</p>
          )}
        </div>

      </div>
    </div>,
    document.body
  );
}


export default ModaleOuverture;
